module.exports = __webpack_public_path__ + "static/media/australia-post.0744ff6b.svg";